import apiClient from '../api/client';
import { ApiResponse } from '../../types/api.types';

export interface AdminJob {
  id: number;
  title: string;
  location: string;
  employment_type: 'Full-time' | 'Part-time' | 'Contract' | 'Internship';
  department: string;
  short_description: string;
  full_description: string;
  responsibilities?: string;
  requirements?: string;
  salary?: string;
  is_active: boolean;
  application_count: number;
  created_at: string;
}

export interface AdminJobApplication {
  id: number;
  job_id: number;
  job_title: string;
  full_name: string;
  email: string;
  phone_number: string;
  resume_path: string;
  resume_url: string;
  cover_letter?: string;
  submitted_at: string;
}

export interface CreateJobData {
  title: string;
  location: string;
  employment_type: string;
  department: string;
  short_description: string;
  full_description: string;
  responsibilities?: string;
  requirements?: string;
  salary?: string;
  is_active?: boolean;
}

class AdminJobService {
  async getAllJobs(): Promise<AdminJob[]> {
    const response = await apiClient.get<ApiResponse<AdminJob[]>>('/admin/jobs');
    return response.data.data;
  }

  async getJobById(id: number | string): Promise<AdminJob> {
    const response = await apiClient.get<ApiResponse<AdminJob>>(`/admin/jobs/${id}`);
    return response.data.data;
  }

  async createJob(data: CreateJobData): Promise<any> {
    const response = await apiClient.post<ApiResponse<any>>('/admin/jobs/create', data);
    return response.data;
  }

  async updateJob(id: number | string, data: Partial<AdminJob>): Promise<any> {
    const response = await apiClient.post<ApiResponse<any>>('/admin/jobs/update', { id, ...data });
    return response.data;
  }

  async toggleJobStatus(id: number | string): Promise<any> {
    const response = await apiClient.post<ApiResponse<any>>('/admin/jobs/toggle-status', { id });
    return response.data;
  }

  async deleteJob(id: number | string): Promise<any> {
    const response = await apiClient.delete<ApiResponse<any>>(`/admin/jobs/${id}`);
    return response.data;
  }

  async getAllApplications(params: { job_id?: number | string } = {}): Promise<AdminJobApplication[]> {
    const response = await apiClient.get<ApiResponse<AdminJobApplication[]>>('/admin/job-applications', { params });
    return response.data.data;
  }

  async getApplicationById(id: number | string): Promise<AdminJobApplication> {
    const response = await apiClient.get<ApiResponse<AdminJobApplication>>(`/admin/job-applications/${id}`);
    return response.data.data;
  }
}

export default new AdminJobService();
